// @noflow
import './accordion.component.css';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

const CONTENT_PREFIX = 'accordion-content';

const propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    contentId: PropTypes.string,
    header: PropTypes.node.isRequired,
    isExpanded: PropTypes.bool,
    onToggle: PropTypes.func
};

const Accordion = ({
    children,
    className,
    contentId = `${CONTENT_PREFIX}-${Math.random().toString(16)}`,
    header,
    isExpanded,
    onToggle
}) => (
    <div className={classnames('accordion', className)}>
        <button
            aria-controls={contentId}
            aria-expanded={isExpanded}
            className="accordion__header"
            onClick={onToggle}
            type="button"
        >
            {header}
        </button>
        <div aria-hidden={!isExpanded} className="accordion__content" id={contentId}>
            {children}
        </div>
    </div>
);

Accordion.propTypes = propTypes;
export default Accordion;



// WEBPACK FOOTER //
// ./src/components/widgets/accordion/accordion.component.js